import axios from "axios";

const envUrl = process.env.REACT_APP_BACKEND_URL;

function resolveBackendUrl() {
  try {
    const envHost = new URL(envUrl).host;
    const pageHost = window.location.host;
    const strip = (h) => h.replace(/^www\./, "");
    if (envHost !== pageHost && strip(envHost) === strip(pageHost)) {
      return window.location.origin;
    }
  } catch { /* use env as-is */ }
  return envUrl;
}

const BACKEND_URL = resolveBackendUrl();
export const API = `${BACKEND_URL}/api`;

export const apiClient = axios.create({
  baseURL: API,
  withCredentials: true,
});

apiClient.interceptors.request.use((config) => {
  try {
    const tok = localStorage.getItem("aurafx_token");
    if (tok && !config.headers.Authorization) config.headers.Authorization = `Bearer ${tok}`;
  } catch { /* storage unavailable */ }
  return config;
});

export const audioSrc = (sound) =>
  sound.audio_b64
    ? `data:${sound.audio_mime || "audio/mpeg"};base64,${sound.audio_b64}`
    : `${API}/sounds/${sound.sound_id}/download?inline=true`;
